// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/*
 * RESPONSIVE TICKET MODALS - COMPREHENSIVE IMPROVEMENTS
 * 
 * This section contains responsive styles specifically designed for:
 * - ViewEditTicketModal (view detail and edit ticket modal)
 * - DuplicateTicketModal (duplicate ticket modal)
 * 
 * Key Responsive Features:
 * 1. Full-width modals on mobile devices (95vw - 98vw)
 * 2. Proper height management (95vh - 98vh max)
 * 3. Flexible layout with flexbox for better content distribution
 * 4. Improved touch targets (44px minimum height for buttons)
 * 5. Better form field spacing and stacking on small screens
 * 6. Optimized text and button sizes for mobile readability
 * 7. Enhanced scrolling for modal content
 * 8. Better table responsiveness with hidden columns on mobile
 * 9. Improved navigation tabs for mobile devices
 * 10. Fixed sidebar consideration in modal positioning
 * 
 * Breakpoints:
 * - Mobile: max-width: 768px (tablets and phones)
 * - Small Mobile: max-width: 576px (phones)
 * - Extra Small: max-width: 480px (small phones)
 * - Landscape: max-width: 768px and orientation: landscape
 * - Height-based: max-height: 600px, 800px (short screens)
 */

/* Responsive Modal Styles */
@media (max-width: 768px) {
  .modal-dialog {
    margin: 0.5rem;
    max-width: calc(100% - 1rem);
    max-height: 85vh;
  }
  
  .modal-xl {
    max-width: calc(100% - 1rem);
    max-height: 85vh;
  }
  
  .modal-content {
    border-radius: 12px;
    max-height: 85vh;
    display: flex;
    flex-direction: column;
  }
  
  .modal-header {
    padding: 1rem;
    border-bottom: 1px solid #e5e9f0;
    flex-shrink: 0;
  }
  
  .modal-title {
    font-size: 1.1rem;
    font-weight: 600;
  }
  
  .modal-body {
    padding: 1rem;
    flex: 1 1;
    overflow-y: auto;
    max-height: calc(85vh - 140px);
  }
  
  .modal-footer {
    padding: 1rem;
    flex-direction: column;
    gap: 0.5rem;
    flex-shrink: 0;
    border-top: 1px solid #e5e9f0;
  }
  
  .modal-footer .btn {
    width: 100%;
    margin: 0;
  }
  
  /* Navigation tabs responsive */
  .nav-tabs {
    flex-wrap: wrap;
    border-bottom: 1px solid #e5e9f0;
    margin-bottom: 1rem;
  }
  
  .nav-tabs .nav-link {
    font-size: 0.875rem;
    padding: 0.5rem 0.75rem;
    white-space: nowrap;
    border: none;
    border-bottom: 2px solid transparent;
  }
  
  .nav-tabs .nav-link.active {
    border-bottom-color: #911311;
    color: #911311;
    background: none;
  }
  
  /* Form responsive adjustments */
  .row {
    margin-left: -0.5rem;
    margin-right: -0.5rem;
  }
  
  .col-md-6,
  .col-md-3 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  
  /* Card responsive */
  .card {
    margin-bottom: 1rem;
  }
  
  .card-body {
    padding: 1rem;
  }
  
  /* Form controls responsive */
  .form-control,
  .form-select {
    font-size: 16px; /* Prevents zoom on iOS */
    padding: 0.75rem 0.875rem;
  }
  
  /* Button responsive */
  .btn {
    padding: 0.75rem 1rem;
    font-size: 0.875rem;
  }
  
  .btn-sm {
    padding: 0.5rem 0.75rem;
    font-size: 0.8rem;
  }
  
  /* Ticket items responsive */
  .ticket-item-card {
    margin-bottom: 1rem;
  }
  
  .ticket-item-card .card-body {
    padding: 1rem;
  }
  
  /* Remove button responsive */
  .btn-outline-danger {
    padding: 0.5rem;
    min-width: 40px;
  }
  
  /* Image gallery responsive */
  .image-gallery {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 0.5rem;
  }
  
  .image-gallery img {
    height: 120px;
    object-fit: cover;
  }
  
  /* Camera modal responsive */
  .camera-modal .modal-dialog {
    max-width: calc(100% - 2rem);
    margin: 1rem;
  }
  
  .camera-modal video {
    width: 100%;
    height: auto;
    max-height: 60vh;
  }
  
  /* Alert responsive */
  .alert {
    margin-bottom: 1rem;
    padding: 0.75rem 1rem;
    font-size: 0.875rem;
  }
  
  /* Better spacing for form groups */
  .form-label {
    margin-bottom: 0.5rem;
    font-weight: 600;
  }
  
  /* Improve select dropdowns on mobile */
  .form-select {
    background-size: 16px 12px;
  }
  
  /* Better touch targets for buttons */
  .btn {
    min-height: 44px;
    touch-action: manipulation;
  }
  
  /* Improve modal scrolling */
  .modal-dialog-scrollable .modal-body {
    max-height: calc(95vh - 140px);
    overflow-y: auto;
  }
  
  /* Force modal to fit screen */
  .modal.show {
    display: flex !important;
    align-items: center;
    justify-content: center;
  }
  
  /* Better textarea sizing */
  textarea.form-control {
    min-height: 60px;
    resize: vertical;
  }
  
  /* Improve form spacing */
  .mb-3 {
    margin-bottom: 1rem !important;
  }
  
  /* Better button spacing */
  .d-flex.justify-content-between {
    flex-wrap: wrap;
    gap: 0.5rem;
  }
  
  /* Specific improvements for ticket modals */
  .modal-dialog .modal-content {
    max-height: 95vh;
    display: flex;
    flex-direction: column;
  }
  
  .modal-dialog .modal-header {
    flex-shrink: 0;
    padding: 1rem;
  }
  
  .modal-dialog .modal-body {
    flex: 1 1;
    overflow-y: auto;
    padding: 1rem;
  }
  
  .modal-dialog .modal-footer {
    flex-shrink: 0;
    padding: 1rem;
  }
  
  /* Improve form field spacing on mobile */
  .row.g-3 > * {
    margin-bottom: 1rem;
  }
  
  /* Better table responsiveness */
  .table-responsive {
    border-radius: 8px;
    overflow: hidden;
  }
  
  /* Improve button groups on mobile */
  .btn-group {
    flex-wrap: wrap;
    gap: 0.25rem;
  }
  
  .btn-group .btn {
    flex: 1 1;
    min-width: auto;
  }
}

@media (max-width: 576px) {
  .modal-dialog {
    margin: 0.25rem;
    max-width: calc(100% - 0.5rem);
    max-height: 85vh;
  }
  
  .modal-xl {
    max-width: calc(100% - 0.5rem);
    max-height: 85vh;
  }
  
  .modal-header {
    padding: 0.75rem;
  }
  
  .modal-body {
    padding: 0.75rem;
    max-height: calc(85vh - 120px);
  }
  
  .modal-footer {
    padding: 0.75rem;
  }
  
  /* Stack form fields vertically on very small screens */
  .row .col-md-6,
  .row .col-md-3 {
    margin-bottom: 1rem;
  }
  
  /* Make buttons more touch-friendly */
  .btn {
    min-height: 44px;
    padding: 0.75rem 1rem;
  }
  
  /* Adjust form labels for better mobile readability */
  .form-label {
    font-size: 0.875rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
  }
  
  /* Improve textarea readability on mobile */
  textarea.form-control {
    min-height: 80px;
    font-size: 16px;
  }
  
  /* Better spacing for ticket items */
  .ticket-item-card {
    margin-bottom: 1.5rem;
  }
  
  .ticket-item-card .card-body {
    padding: 1rem;
  }
  
  /* Improve navigation tabs on mobile */
  .nav-tabs {
    border-bottom: 1px solid #e5e9f0;
  }
  
  .nav-tabs .nav-link {
    padding: 0.75rem 0.5rem;
    font-size: 0.8rem;
    border: none;
    border-bottom: 2px solid transparent;
  }
  
  .nav-tabs .nav-link.active {
    border-bottom-color: #911311;
    color: #911311;
    background: none;
  }
  
  /* Better image upload area */
  .image-upload-area {
    padding: 2rem 1rem;
    border: 2px dashed #e5e9f0;
    border-radius: 8px;
    text-align: center;
  }
  
  .image-upload-area.dragover {
    border-color: #911311;
    background-color: rgba(145, 19, 17, 0.05);
  }
  
  /* Improve modal content scrolling */
  .modal-dialog-scrollable {
    max-height: 85vh;
  }
  
  .modal-dialog-scrollable .modal-content {
    max-height: 85vh;
  }
  
  .modal-dialog-scrollable .modal-body {
    max-height: calc(98vh - 120px);
    overflow-y: auto;
  }
  
  /* Better form spacing on very small screens */
  .row.g-3 > * {
    margin-bottom: 1rem;
  }
  
  /* Improve button spacing in modals */
  .modal-footer .btn {
    margin-bottom: 0.5rem;
  }
  
  .modal-footer .btn:last-child {
    margin-bottom: 0;
  }
  
  /* Force better modal positioning */
  .modal.show {
    padding: 0.5rem;
  }
  
  /* Better textarea sizing for mobile */
  textarea.form-control {
    min-height: 70px;
    max-height: 120px;
  }
  
  /* Improve form field spacing */
  .form-group {
    margin-bottom: 1rem;
  }
  
  /* Better card spacing */
  .card {
    margin-bottom: 1rem;
  }
  
  .card-body {
    padding: 0.75rem;
  }
  
  /* Specific improvements for ticket modals on small screens */
  .modal-dialog .modal-content {
    max-height: 98vh;
    border-radius: 12px;
  }
  
  .modal-dialog .modal-header {
    padding: 0.75rem;
    border-bottom: 1px solid #e5e9f0;
  }
  
  .modal-dialog .modal-body {
    padding: 0.75rem;
    max-height: calc(98vh - 120px);
  }
  
  .modal-dialog .modal-footer {
    padding: 0.75rem;
    border-top: 1px solid #e5e9f0;
  }
  
  /* Improve form layout on small screens */
  .row.g-3 > * {
    margin-bottom: 0.75rem;
  }
  
  /* Better button sizing for small screens */
  .btn-sm {
    padding: 0.375rem 0.5rem;
    font-size: 0.75rem;
  }
  
  /* Reduce textarea height further */
  textarea.form-control {
    min-height: 60px;
    max-height: 100px;
  }
  
  /* Better modal positioning */
  .modal.show {
    padding: 0.25rem;
  }
  
  /* Improve table responsiveness */
  .table-responsive {
    font-size: 0.875rem;
  }
  
  .table-responsive .table {
    font-size: 0.875rem;
  }
  
  /* Better button groups on small screens */
  .btn-group {
    flex-direction: column;
    gap: 0.25rem;
  }
  
  .btn-group .btn {
    width: 100%;
    margin: 0;
  }
}

/* Landscape orientation adjustments */
@media (max-width: 768px) and (orientation: landscape) {
  .modal-dialog {
    max-height: 85vh;
    margin: 0.5rem;
  }
  
  .modal-content {
    max-height: 85vh;
    overflow-y: auto;
  }
  
  .modal-body {
    max-height: 50vh;
    overflow-y: auto;
  }
  
  /* Reduce textarea height in landscape */
  textarea.form-control {
    min-height: 50px;
    max-height: 80px;
  }
}

/* High DPI displays */
@media (min-resolution: 192dpi) {
  .modal-content {
    border: 1px solid #e5e9f0;
  }
  
  .btn {
    border-width: 1px;
  }
}

/* Accessibility improvements */
@media (prefers-reduced-motion: reduce) {
  .modal,
  .btn,
  .form-control {
    transition: none;
  }
}

/* Dark mode support (if needed in future) */
@media (prefers-color-scheme: dark) {
  /* Dark mode styles can be added here */
}

/* Print styles */
@media print {
  .print-hidden {
    display: none !important;
  }

  .app-main-print {
    margin-left: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
    padding: 0.5rem !important;
  }

  .schedule-print-root {
    max-width: 100% !important;
  }

  /* Match customer email: gray shell, white card, burgundy header, footer strip */
  .schedule-print-email-branded {
    background-color: #f4f4f4 !important;
    padding: 12px 16px !important;
    margin: -4px -8px 0 !important;
    print-color-adjust: exact !important;
  }

  .schedule-print-email-card {
    max-width: 100% !important;
    background-color: #ffffff !important;
    border-radius: 8px !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08) !important;
    overflow: hidden !important;
    border: 1px solid #e8e8e8 !important;
  }

  .schedule-print-email-header-bar {
    background-color: #911311 !important;
    padding: 22px 32px !important;
    border-radius: 8px 8px 0 0 !important;
    page-break-after: avoid;
    break-after: avoid-page;
    print-color-adjust: exact !important;
  }

  .schedule-print-email-header-bar img {
    print-color-adjust: exact !important;
  }

  .schedule-print-email-content-wrap {
    padding: 28px 36px 12px !important;
  }

  .schedule-print-email-footer {
    background-color: #f8fafc !important;
    padding: 22px 32px !important;
    border-top: 1px solid #e5e9f0 !important;
    border-radius: 0 0 8px 8px !important;
    page-break-inside: avoid;
    print-color-adjust: exact !important;
  }

  .schedule-print-entries-table {
    page-break-inside: auto;
  }

  .schedule-print-entries-table tbody tr {
    page-break-inside: avoid;
    break-inside: avoid-page;
  }

  .schedule-print-entries-table th,
  .schedule-print-entries-table td {
    print-color-adjust: exact !important;
  }

  .schedule-print-root .schedule-calendar-frame {
    min-height: auto !important;
    overflow: visible !important;
    page-break-inside: avoid;
    break-inside: avoid-page;
    border: none !important;
    box-shadow: none !important;
    border-radius: 0 !important;
    background: transparent !important;
  }

  .schedule-print-root .schedule-calendar-scroll {
    overflow: visible !important;
  }

  .schedule-print-root .schedule-calendar-inner {
    min-width: 0 !important;
    width: 100% !important;
  }

  .schedule-print-root .schedule-calendar-grid {
    width: 100% !important;
  }

  .schedule-print-root .schedule-weekday-header {
    font-size: 7pt !important;
  }

  .schedule-print-root .schedule-weekday-header > div {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .schedule-print-root .schedule-day-cell {
    min-height: 46px !important;
    padding: 2px !important;
    vertical-align: top;
  }

  .schedule-print-root .schedule-weekday-header,
  .schedule-print-root .schedule-day-cell,
  .schedule-print-root .schedule-entry-chip {
    print-color-adjust: exact !important;
    color-adjust: exact !important;
  }

  .schedule-print-root .schedule-entry-chip {
    font-size: 5.5pt !important;
    line-height: 1.15 !important;
    white-space: normal !important;
    word-break: break-word !important;
    overflow: visible !important;
    text-overflow: clip !important;
    padding: 2px !important;
    max-width: none !important;
  }

  .modal-backdrop,
  .modal {
    display: none !important;
  }
}

/* Additional responsive improvements */
@media (max-width: 480px) {
  /* Extra small screens */
  .modal-dialog {
    margin: 0.125rem;
    max-width: calc(100% - 0.25rem);
    max-height: 85vh;
  }
  
  .modal-header {
    padding: 0.5rem;
  }
  
  .modal-body {
    padding: 0.5rem;
    max-height: calc(85vh - 100px);
  }
  
  .modal-footer {
    padding: 0.5rem;
  }
  
  /* Smaller text for very small screens */
  .modal-title {
    font-size: 1rem;
  }
  
  .form-label {
    font-size: 0.8rem;
  }
  
  .btn {
    font-size: 0.8rem;
    padding: 0.5rem 0.75rem;
  }
  
  /* Better spacing for form elements */
  .row.g-3 > * {
    margin-bottom: 0.75rem;
  }
  
  /* Improve card spacing */
  .card-body {
    padding: 0.75rem;
  }
  
  /* Better button sizing for small screens */
  .btn-sm {
    padding: 0.375rem 0.5rem;
    font-size: 0.75rem;
  }
  
  /* Reduce textarea height further */
  textarea.form-control {
    min-height: 60px;
    max-height: 100px;
  }
  
  /* Better modal positioning */
  .modal.show {
    padding: 0.25rem;
  }
}

/* Critical fixes for modal overflow */
@media (max-height: 600px) {
  .modal-dialog {
    max-height: 95vh;
    margin: 0.25rem;
  }
  
  .modal-content {
    max-height: 95vh;
  }
  
  .modal-body {
    max-height: calc(95vh - 100px);
    overflow-y: auto;
  }
  
  /* Reduce textarea heights for short screens */
  textarea.form-control {
    min-height: 50px;
    max-height: 80px;
  }
  
  /* Stack form fields more aggressively */
  .row .col-md-6,
  .row .col-md-3 {
    margin-bottom: 0.75rem;
  }
  
  /* Reduce spacing */
  .mb-3 {
    margin-bottom: 0.75rem !important;
  }
  
  .card-body {
    padding: 0.5rem;
  }
}

/* Additional fixes for very tall modals */
@media (max-height: 800px) {
  .modal-dialog {
    max-height: 90vh;
  }
  
  .modal-content {
    max-height: 90vh;
  }
  
  .modal-body {
    max-height: calc(90vh - 120px);
    overflow-y: auto;
  }
  
  /* Reduce textarea heights */
  textarea.form-control {
    min-height: 60px;
    max-height: 100px;
  }
  
  /* Reduce form spacing */
  .mb-3 {
    margin-bottom: 0.75rem !important;
  }
  
  .card-body {
    padding: 0.75rem;
  }
  
  /* Better button spacing */
  .d-flex.justify-content-between {
    margin-bottom: 0.75rem;
  }
}

/* Fix for modal content overflow */
.modal-dialog-scrollable .modal-content {
  max-height: 100vh;
  overflow: hidden;
}

.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
  overflow-x: hidden;
}

/* Better form field spacing */
.form-group {
  margin-bottom: 1rem;
}

.form-group:last-child {
  margin-bottom: 0;
}

/* Improve textarea resizing */
textarea.form-control {
  resize: vertical;
  min-height: 60px;
}

/* Better modal backdrop */
.modal-backdrop {
  backdrop-filter: blur(4px);
}

/* Comprehensive modal fixes for fixed sidebar */
.modal,
.modal.show {
  z-index: 1500 !important;
}

.modal-backdrop,
.modal-backdrop.show {
  z-index: 1400 !important;
}

/* Ensure all modals appear above sidebar */
.modal-dialog {
  z-index: 1500 !important;
}

.modal-content {
  z-index: 1500 !important;
}

/* Ensure modals appear above sidebar */
.modal.show {
  display: flex !important;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  z-index: 1500 !important;
}

/* Responsive modal positioning to account for fixed sidebar */
@media (min-width: 992px) {
  .modal.show {
    padding-left: calc(280px + 1rem) !important; /* Account for sidebar width */
  }
  
  .modal-dialog {
    margin-left: auto !important;
    margin-right: auto !important;
  }
}

@media (max-width: 991px) {
  .modal.show {
    padding: 0.5rem !important;
  }
}

@media (max-width: 768px) {
  .modal.show {
    padding: 0.5rem !important;
  }
}

@media (max-width: 576px) {
  .modal.show {
    padding: 0.25rem !important;
  }
}

/* --------------------------------------------------------------------------
   Global modal responsiveness — applies to every Bootstrap modal in the app
   (fixes inline maxWidth, overflow on small viewports, and notched devices)
   -------------------------------------------------------------------------- */
.modal {
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}

/* Never wider than the viewport; respect Bootstrap size modifiers via --bs-modal-width */
.modal .modal-dialog {
  width: 100%;
  max-width: min(var(--bs-modal-width, 500px), calc(100vw - 1.5rem)) !important;
  margin-left: auto !important;
  margin-right: auto !important;
}

/* Cap modal height; keep header/footer visible, scroll the body */
.modal .modal-content {
  max-height: min(92vh, 92dvh);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.modal .modal-header,
.modal .modal-footer {
  flex-shrink: 0;
}

.modal .modal-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
}

/* Users page (and similar): <form> wraps .modal-body + .modal-footer */
.modal .modal-content > form {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.modal .modal-content > form .modal-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
}

.modal .modal-content > form .modal-footer {
  flex-shrink: 0;
}

@media (max-width: 991px) {
  .modal.show {
    padding-left: max(0.5rem, env(safe-area-inset-left, 0px)) !important;
    padding-right: max(0.5rem, env(safe-area-inset-right, 0px)) !important;
    padding-bottom: max(0.5rem, env(safe-area-inset-bottom, 0px)) !important;
  }
}

@media (max-height: 520px) {
  .modal.show {
    align-items: flex-start !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;EAyBE;;AAEF,4BAA4B;AAC5B;EACE;IACE,cAAc;IACd,4BAA4B;IAC5B,gBAAgB;EAClB;;EAEA;IACE,4BAA4B;IAC5B,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,gCAAgC;IAChC,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,SAAO;IACP,gBAAgB;IAChB,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,cAAc;IACd,6BAA6B;EAC/B;;EAEA;IACE,WAAW;IACX,SAAS;EACX;;EAEA,+BAA+B;EAC/B;IACE,eAAe;IACf,gCAAgC;IAChC,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,oCAAoC;EACtC;;EAEA;IACE,4BAA4B;IAC5B,cAAc;IACd,gBAAgB;EAClB;;EAEA,gCAAgC;EAChC;IACE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;;IAEE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA,oBAAoB;EACpB;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA,6BAA6B;EAC7B;;IAEE,eAAe,EAAE,yBAAyB;IAC1C,yBAAyB;EAC3B;;EAEA,sBAAsB;EACtB;IACE,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA,4BAA4B;EAC5B;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA,6BAA6B;EAC7B;IACE,eAAe;IACf,eAAe;EACjB;;EAEA,6BAA6B;EAC7B;IACE,4DAA4D;IAC5D,WAAW;EACb;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA,4BAA4B;EAC5B;IACE,4BAA4B;IAC5B,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;;EAEA,qBAAqB;EACrB;IACE,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA,mCAAmC;EACnC;IACE,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA,uCAAuC;EACvC;IACE,0BAA0B;EAC5B;;EAEA,qCAAqC;EACrC;IACE,gBAAgB;IAChB,0BAA0B;EAC5B;;EAEA,4BAA4B;EAC5B;IACE,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA,8BAA8B;EAC9B;IACE,wBAAwB;IACxB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA,2BAA2B;EAC3B;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA,yBAAyB;EACzB;IACE,8BAA8B;EAChC;;EAEA,0BAA0B;EAC1B;IACE,eAAe;IACf,WAAW;EACb;;EAEA,4CAA4C;EAC5C;IACE,gBAAgB;IAChB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA,yCAAyC;EACzC;IACE,mBAAmB;EACrB;;EAEA,gCAAgC;EAChC;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA,oCAAoC;EACpC;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,SAAO;IACP,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,8BAA8B;EAChC;;EAEA;IACE,gBAAgB;EAClB;;EAEA,uDAAuD;EACvD;;IAEE,mBAAmB;EACrB;;EAEA,qCAAqC;EACrC;IACE,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA,qDAAqD;EACrD;IACE,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA,2CAA2C;EAC3C;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA,oCAAoC;EACpC;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA,sCAAsC;EACtC;IACE,gCAAgC;EAClC;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;IACjB,YAAY;IACZ,oCAAoC;EACtC;;EAEA;IACE,4BAA4B;IAC5B,cAAc;IACd,gBAAgB;EAClB;;EAEA,6BAA6B;EAC7B;IACE,kBAAkB;IAClB,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,yCAAyC;EAC3C;;EAEA,oCAAoC;EACpC;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA,8CAA8C;EAC9C;IACE,mBAAmB;EACrB;;EAEA,qCAAqC;EACrC;IACE,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;EAClB;;EAEA,mCAAmC;EACnC;IACE,eAAe;EACjB;;EAEA,sCAAsC;EACtC;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA,+BAA+B;EAC/B;IACE,mBAAmB;EACrB;;EAEA,wBAAwB;EACxB;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA,6DAA6D;EAC7D;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA;IACE,gBAAgB;IAChB,8BAA8B;EAChC;;EAEA;IACE,gBAAgB;IAChB,6BAA6B;EAC/B;;EAEA,yCAAyC;EACzC;IACE,sBAAsB;EACxB;;EAEA,2CAA2C;EAC3C;IACE,wBAAwB;IACxB,kBAAkB;EACpB;;EAEA,mCAAmC;EACnC;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA,6BAA6B;EAC7B;IACE,gBAAgB;EAClB;;EAEA,iCAAiC;EACjC;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA,0CAA0C;EAC1C;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,SAAS;EACX;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA,wCAAwC;EACxC;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,+BAA+B;AAC/B;EACE;;;IAGE,gBAAgB;EAClB;AACF;;AAEA,4CAA4C;AAC5C;EACE,uCAAuC;AACzC;;AAEA,iBAAiB;AACjB;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,0BAA0B;IAC1B,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,gFAAgF;EAChF;IACE,oCAAoC;IACpC,6BAA6B;IAC7B,8BAA8B;IAE9B,oCAAoC;EACtC;;EAEA;IACE,0BAA0B;IAC1B,oCAAoC;IACpC,6BAA6B;IAC7B,oDAAoD;IACpD,2BAA2B;IAC3B,oCAAoC;EACtC;;EAEA;IACE,oCAAoC;IACpC,6BAA6B;IAC7B,qCAAqC;IACrC,uBAAuB;IACvB,uBAAuB;IAEvB,oCAAoC;EACtC;;EAEA;IAEE,oCAAoC;EACtC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,oCAAoC;IACpC,6BAA6B;IAC7B,wCAAwC;IACxC,qCAAqC;IACrC,wBAAwB;IAExB,oCAAoC;EACtC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;;EAEA;;IAGE,oCAAoC;EACtC;;EAEA;IACE,2BAA2B;IAC3B,4BAA4B;IAC5B,wBAAwB;IACxB,wBAAwB;IACxB,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;IAC3B,kCAAkC;EACpC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,+BAA+B;IAC/B,kCAAkC;EACpC;;EAEA;IACE,2BAA2B;IAC3B,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;;;IAIE,oCAAoC;IACpC,8BAA8B;EAChC;;EAEA;IACE,2BAA2B;IAC3B,4BAA4B;IAC5B,8BAA8B;IAC9B,iCAAiC;IACjC,4BAA4B;IAC5B,8BAA8B;IAC9B,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;;IAEE,wBAAwB;EAC1B;AACF;;AAEA,uCAAuC;AACvC;EACE,wBAAwB;EACxB;IACE,gBAAgB;IAChB,+BAA+B;IAC/B,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,8BAA8B;EAChC;;EAEA;IACE,eAAe;EACjB;;EAEA,wCAAwC;EACxC;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA,qCAAqC;EACrC;IACE,sBAAsB;EACxB;;EAEA,yBAAyB;EACzB;IACE,gBAAgB;EAClB;;EAEA,2CAA2C;EAC3C;IACE,wBAAwB;IACxB,kBAAkB;EACpB;;EAEA,mCAAmC;EACnC;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA,6BAA6B;EAC7B;IACE,gBAAgB;EAClB;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA,8CAA8C;EAC9C;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA,wCAAwC;EACxC;;IAEE,sBAAsB;EACxB;;EAEA,mBAAmB;EACnB;IACE,iCAAiC;EACnC;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,0CAA0C;AAC1C;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA,4BAA4B;EAC5B;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA,wBAAwB;EACxB;IACE,iCAAiC;EACnC;;EAEA;IACE,gBAAgB;EAClB;;EAEA,0BAA0B;EAC1B;IACE,sBAAsB;EACxB;AACF;;AAEA,mCAAmC;AACnC;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,0BAA0B;AAC5B;;AAEA,gDAAgD;AAChD;;EAEE,wBAAwB;AAC1B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA,2CAA2C;AAC3C;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,uCAAuC;AACvC;EACE,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,wBAAwB;AAC1B;;AAEA,8DAA8D;AAC9D;EACE;IACE,2CAA2C,EAAE,8BAA8B;EAC7E;;EAEA;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;;;+EAG+E;AAC/E;EACE,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA,yFAAyF;AACzF;EACE,WAAW;EACX,6EAA6E;EAC7E,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA,kEAAkE;AAClE;EACE,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,uEAAuE;AACvE;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,oEAAoE;IACpE,sEAAsE;IACtE,wEAAwE;EAC1E;AACF;;AAEA;EACE;IACE,kCAAkC;EACpC;AACF","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/*\n * RESPONSIVE TICKET MODALS - COMPREHENSIVE IMPROVEMENTS\n * \n * This section contains responsive styles specifically designed for:\n * - ViewEditTicketModal (view detail and edit ticket modal)\n * - DuplicateTicketModal (duplicate ticket modal)\n * \n * Key Responsive Features:\n * 1. Full-width modals on mobile devices (95vw - 98vw)\n * 2. Proper height management (95vh - 98vh max)\n * 3. Flexible layout with flexbox for better content distribution\n * 4. Improved touch targets (44px minimum height for buttons)\n * 5. Better form field spacing and stacking on small screens\n * 6. Optimized text and button sizes for mobile readability\n * 7. Enhanced scrolling for modal content\n * 8. Better table responsiveness with hidden columns on mobile\n * 9. Improved navigation tabs for mobile devices\n * 10. Fixed sidebar consideration in modal positioning\n * \n * Breakpoints:\n * - Mobile: max-width: 768px (tablets and phones)\n * - Small Mobile: max-width: 576px (phones)\n * - Extra Small: max-width: 480px (small phones)\n * - Landscape: max-width: 768px and orientation: landscape\n * - Height-based: max-height: 600px, 800px (short screens)\n */\n\n/* Responsive Modal Styles */\n@media (max-width: 768px) {\n  .modal-dialog {\n    margin: 0.5rem;\n    max-width: calc(100% - 1rem);\n    max-height: 85vh;\n  }\n  \n  .modal-xl {\n    max-width: calc(100% - 1rem);\n    max-height: 85vh;\n  }\n  \n  .modal-content {\n    border-radius: 12px;\n    max-height: 85vh;\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .modal-header {\n    padding: 1rem;\n    border-bottom: 1px solid #e5e9f0;\n    flex-shrink: 0;\n  }\n  \n  .modal-title {\n    font-size: 1.1rem;\n    font-weight: 600;\n  }\n  \n  .modal-body {\n    padding: 1rem;\n    flex: 1;\n    overflow-y: auto;\n    max-height: calc(85vh - 140px);\n  }\n  \n  .modal-footer {\n    padding: 1rem;\n    flex-direction: column;\n    gap: 0.5rem;\n    flex-shrink: 0;\n    border-top: 1px solid #e5e9f0;\n  }\n  \n  .modal-footer .btn {\n    width: 100%;\n    margin: 0;\n  }\n  \n  /* Navigation tabs responsive */\n  .nav-tabs {\n    flex-wrap: wrap;\n    border-bottom: 1px solid #e5e9f0;\n    margin-bottom: 1rem;\n  }\n  \n  .nav-tabs .nav-link {\n    font-size: 0.875rem;\n    padding: 0.5rem 0.75rem;\n    white-space: nowrap;\n    border: none;\n    border-bottom: 2px solid transparent;\n  }\n  \n  .nav-tabs .nav-link.active {\n    border-bottom-color: #911311;\n    color: #911311;\n    background: none;\n  }\n  \n  /* Form responsive adjustments */\n  .row {\n    margin-left: -0.5rem;\n    margin-right: -0.5rem;\n  }\n  \n  .col-md-6,\n  .col-md-3 {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n  }\n  \n  /* Card responsive */\n  .card {\n    margin-bottom: 1rem;\n  }\n  \n  .card-body {\n    padding: 1rem;\n  }\n  \n  /* Form controls responsive */\n  .form-control,\n  .form-select {\n    font-size: 16px; /* Prevents zoom on iOS */\n    padding: 0.75rem 0.875rem;\n  }\n  \n  /* Button responsive */\n  .btn {\n    padding: 0.75rem 1rem;\n    font-size: 0.875rem;\n  }\n  \n  .btn-sm {\n    padding: 0.5rem 0.75rem;\n    font-size: 0.8rem;\n  }\n  \n  /* Ticket items responsive */\n  .ticket-item-card {\n    margin-bottom: 1rem;\n  }\n  \n  .ticket-item-card .card-body {\n    padding: 1rem;\n  }\n  \n  /* Remove button responsive */\n  .btn-outline-danger {\n    padding: 0.5rem;\n    min-width: 40px;\n  }\n  \n  /* Image gallery responsive */\n  .image-gallery {\n    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n    gap: 0.5rem;\n  }\n  \n  .image-gallery img {\n    height: 120px;\n    object-fit: cover;\n  }\n  \n  /* Camera modal responsive */\n  .camera-modal .modal-dialog {\n    max-width: calc(100% - 2rem);\n    margin: 1rem;\n  }\n  \n  .camera-modal video {\n    width: 100%;\n    height: auto;\n    max-height: 60vh;\n  }\n  \n  /* Alert responsive */\n  .alert {\n    margin-bottom: 1rem;\n    padding: 0.75rem 1rem;\n    font-size: 0.875rem;\n  }\n  \n  /* Better spacing for form groups */\n  .form-label {\n    margin-bottom: 0.5rem;\n    font-weight: 600;\n  }\n  \n  /* Improve select dropdowns on mobile */\n  .form-select {\n    background-size: 16px 12px;\n  }\n  \n  /* Better touch targets for buttons */\n  .btn {\n    min-height: 44px;\n    touch-action: manipulation;\n  }\n  \n  /* Improve modal scrolling */\n  .modal-dialog-scrollable .modal-body {\n    max-height: calc(95vh - 140px);\n    overflow-y: auto;\n  }\n  \n  /* Force modal to fit screen */\n  .modal.show {\n    display: flex !important;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  /* Better textarea sizing */\n  textarea.form-control {\n    min-height: 60px;\n    resize: vertical;\n  }\n  \n  /* Improve form spacing */\n  .mb-3 {\n    margin-bottom: 1rem !important;\n  }\n  \n  /* Better button spacing */\n  .d-flex.justify-content-between {\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n  \n  /* Specific improvements for ticket modals */\n  .modal-dialog .modal-content {\n    max-height: 95vh;\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .modal-dialog .modal-header {\n    flex-shrink: 0;\n    padding: 1rem;\n  }\n  \n  .modal-dialog .modal-body {\n    flex: 1;\n    overflow-y: auto;\n    padding: 1rem;\n  }\n  \n  .modal-dialog .modal-footer {\n    flex-shrink: 0;\n    padding: 1rem;\n  }\n  \n  /* Improve form field spacing on mobile */\n  .row.g-3 > * {\n    margin-bottom: 1rem;\n  }\n  \n  /* Better table responsiveness */\n  .table-responsive {\n    border-radius: 8px;\n    overflow: hidden;\n  }\n  \n  /* Improve button groups on mobile */\n  .btn-group {\n    flex-wrap: wrap;\n    gap: 0.25rem;\n  }\n  \n  .btn-group .btn {\n    flex: 1;\n    min-width: auto;\n  }\n}\n\n@media (max-width: 576px) {\n  .modal-dialog {\n    margin: 0.25rem;\n    max-width: calc(100% - 0.5rem);\n    max-height: 85vh;\n  }\n  \n  .modal-xl {\n    max-width: calc(100% - 0.5rem);\n    max-height: 85vh;\n  }\n  \n  .modal-header {\n    padding: 0.75rem;\n  }\n  \n  .modal-body {\n    padding: 0.75rem;\n    max-height: calc(85vh - 120px);\n  }\n  \n  .modal-footer {\n    padding: 0.75rem;\n  }\n  \n  /* Stack form fields vertically on very small screens */\n  .row .col-md-6,\n  .row .col-md-3 {\n    margin-bottom: 1rem;\n  }\n  \n  /* Make buttons more touch-friendly */\n  .btn {\n    min-height: 44px;\n    padding: 0.75rem 1rem;\n  }\n  \n  /* Adjust form labels for better mobile readability */\n  .form-label {\n    font-size: 0.875rem;\n    font-weight: 600;\n    margin-bottom: 0.5rem;\n  }\n  \n  /* Improve textarea readability on mobile */\n  textarea.form-control {\n    min-height: 80px;\n    font-size: 16px;\n  }\n  \n  /* Better spacing for ticket items */\n  .ticket-item-card {\n    margin-bottom: 1.5rem;\n  }\n  \n  .ticket-item-card .card-body {\n    padding: 1rem;\n  }\n  \n  /* Improve navigation tabs on mobile */\n  .nav-tabs {\n    border-bottom: 1px solid #e5e9f0;\n  }\n  \n  .nav-tabs .nav-link {\n    padding: 0.75rem 0.5rem;\n    font-size: 0.8rem;\n    border: none;\n    border-bottom: 2px solid transparent;\n  }\n  \n  .nav-tabs .nav-link.active {\n    border-bottom-color: #911311;\n    color: #911311;\n    background: none;\n  }\n  \n  /* Better image upload area */\n  .image-upload-area {\n    padding: 2rem 1rem;\n    border: 2px dashed #e5e9f0;\n    border-radius: 8px;\n    text-align: center;\n  }\n  \n  .image-upload-area.dragover {\n    border-color: #911311;\n    background-color: rgba(145, 19, 17, 0.05);\n  }\n  \n  /* Improve modal content scrolling */\n  .modal-dialog-scrollable {\n    max-height: 85vh;\n  }\n  \n  .modal-dialog-scrollable .modal-content {\n    max-height: 85vh;\n  }\n  \n  .modal-dialog-scrollable .modal-body {\n    max-height: calc(98vh - 120px);\n    overflow-y: auto;\n  }\n  \n  /* Better form spacing on very small screens */\n  .row.g-3 > * {\n    margin-bottom: 1rem;\n  }\n  \n  /* Improve button spacing in modals */\n  .modal-footer .btn {\n    margin-bottom: 0.5rem;\n  }\n  \n  .modal-footer .btn:last-child {\n    margin-bottom: 0;\n  }\n  \n  /* Force better modal positioning */\n  .modal.show {\n    padding: 0.5rem;\n  }\n  \n  /* Better textarea sizing for mobile */\n  textarea.form-control {\n    min-height: 70px;\n    max-height: 120px;\n  }\n  \n  /* Improve form field spacing */\n  .form-group {\n    margin-bottom: 1rem;\n  }\n  \n  /* Better card spacing */\n  .card {\n    margin-bottom: 1rem;\n  }\n  \n  .card-body {\n    padding: 0.75rem;\n  }\n  \n  /* Specific improvements for ticket modals on small screens */\n  .modal-dialog .modal-content {\n    max-height: 98vh;\n    border-radius: 12px;\n  }\n  \n  .modal-dialog .modal-header {\n    padding: 0.75rem;\n    border-bottom: 1px solid #e5e9f0;\n  }\n  \n  .modal-dialog .modal-body {\n    padding: 0.75rem;\n    max-height: calc(98vh - 120px);\n  }\n  \n  .modal-dialog .modal-footer {\n    padding: 0.75rem;\n    border-top: 1px solid #e5e9f0;\n  }\n  \n  /* Improve form layout on small screens */\n  .row.g-3 > * {\n    margin-bottom: 0.75rem;\n  }\n  \n  /* Better button sizing for small screens */\n  .btn-sm {\n    padding: 0.375rem 0.5rem;\n    font-size: 0.75rem;\n  }\n  \n  /* Reduce textarea height further */\n  textarea.form-control {\n    min-height: 60px;\n    max-height: 100px;\n  }\n  \n  /* Better modal positioning */\n  .modal.show {\n    padding: 0.25rem;\n  }\n  \n  /* Improve table responsiveness */\n  .table-responsive {\n    font-size: 0.875rem;\n  }\n  \n  .table-responsive .table {\n    font-size: 0.875rem;\n  }\n  \n  /* Better button groups on small screens */\n  .btn-group {\n    flex-direction: column;\n    gap: 0.25rem;\n  }\n  \n  .btn-group .btn {\n    width: 100%;\n    margin: 0;\n  }\n}\n\n/* Landscape orientation adjustments */\n@media (max-width: 768px) and (orientation: landscape) {\n  .modal-dialog {\n    max-height: 85vh;\n    margin: 0.5rem;\n  }\n  \n  .modal-content {\n    max-height: 85vh;\n    overflow-y: auto;\n  }\n  \n  .modal-body {\n    max-height: 50vh;\n    overflow-y: auto;\n  }\n  \n  /* Reduce textarea height in landscape */\n  textarea.form-control {\n    min-height: 50px;\n    max-height: 80px;\n  }\n}\n\n/* High DPI displays */\n@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {\n  .modal-content {\n    border: 1px solid #e5e9f0;\n  }\n  \n  .btn {\n    border-width: 1px;\n  }\n}\n\n/* Accessibility improvements */\n@media (prefers-reduced-motion: reduce) {\n  .modal,\n  .btn,\n  .form-control {\n    transition: none;\n  }\n}\n\n/* Dark mode support (if needed in future) */\n@media (prefers-color-scheme: dark) {\n  /* Dark mode styles can be added here */\n}\n\n/* Print styles */\n@media print {\n  .print-hidden {\n    display: none !important;\n  }\n\n  .app-main-print {\n    margin-left: 0 !important;\n    width: 100% !important;\n    max-width: 100% !important;\n    padding: 0.5rem !important;\n  }\n\n  .schedule-print-root {\n    max-width: 100% !important;\n  }\n\n  /* Match customer email: gray shell, white card, burgundy header, footer strip */\n  .schedule-print-email-branded {\n    background-color: #f4f4f4 !important;\n    padding: 12px 16px !important;\n    margin: -4px -8px 0 !important;\n    -webkit-print-color-adjust: exact !important;\n    print-color-adjust: exact !important;\n  }\n\n  .schedule-print-email-card {\n    max-width: 100% !important;\n    background-color: #ffffff !important;\n    border-radius: 8px !important;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08) !important;\n    overflow: hidden !important;\n    border: 1px solid #e8e8e8 !important;\n  }\n\n  .schedule-print-email-header-bar {\n    background-color: #911311 !important;\n    padding: 22px 32px !important;\n    border-radius: 8px 8px 0 0 !important;\n    page-break-after: avoid;\n    break-after: avoid-page;\n    -webkit-print-color-adjust: exact !important;\n    print-color-adjust: exact !important;\n  }\n\n  .schedule-print-email-header-bar img {\n    -webkit-print-color-adjust: exact !important;\n    print-color-adjust: exact !important;\n  }\n\n  .schedule-print-email-content-wrap {\n    padding: 28px 36px 12px !important;\n  }\n\n  .schedule-print-email-footer {\n    background-color: #f8fafc !important;\n    padding: 22px 32px !important;\n    border-top: 1px solid #e5e9f0 !important;\n    border-radius: 0 0 8px 8px !important;\n    page-break-inside: avoid;\n    -webkit-print-color-adjust: exact !important;\n    print-color-adjust: exact !important;\n  }\n\n  .schedule-print-entries-table {\n    page-break-inside: auto;\n  }\n\n  .schedule-print-entries-table tbody tr {\n    page-break-inside: avoid;\n    break-inside: avoid-page;\n  }\n\n  .schedule-print-entries-table th,\n  .schedule-print-entries-table td {\n    -webkit-print-color-adjust: exact !important;\n    print-color-adjust: exact !important;\n  }\n\n  .schedule-print-root .schedule-calendar-frame {\n    min-height: auto !important;\n    overflow: visible !important;\n    page-break-inside: avoid;\n    break-inside: avoid-page;\n    border: none !important;\n    box-shadow: none !important;\n    border-radius: 0 !important;\n    background: transparent !important;\n  }\n\n  .schedule-print-root .schedule-calendar-scroll {\n    overflow: visible !important;\n  }\n\n  .schedule-print-root .schedule-calendar-inner {\n    min-width: 0 !important;\n    width: 100% !important;\n  }\n\n  .schedule-print-root .schedule-calendar-grid {\n    width: 100% !important;\n  }\n\n  .schedule-print-root .schedule-weekday-header {\n    font-size: 7pt !important;\n  }\n\n  .schedule-print-root .schedule-weekday-header > div {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n\n  .schedule-print-root .schedule-day-cell {\n    min-height: 46px !important;\n    padding: 2px !important;\n    vertical-align: top;\n  }\n\n  .schedule-print-root .schedule-weekday-header,\n  .schedule-print-root .schedule-day-cell,\n  .schedule-print-root .schedule-entry-chip {\n    -webkit-print-color-adjust: exact !important;\n    print-color-adjust: exact !important;\n    color-adjust: exact !important;\n  }\n\n  .schedule-print-root .schedule-entry-chip {\n    font-size: 5.5pt !important;\n    line-height: 1.15 !important;\n    white-space: normal !important;\n    word-break: break-word !important;\n    overflow: visible !important;\n    text-overflow: clip !important;\n    padding: 2px !important;\n    max-width: none !important;\n  }\n\n  .modal-backdrop,\n  .modal {\n    display: none !important;\n  }\n}\n\n/* Additional responsive improvements */\n@media (max-width: 480px) {\n  /* Extra small screens */\n  .modal-dialog {\n    margin: 0.125rem;\n    max-width: calc(100% - 0.25rem);\n    max-height: 85vh;\n  }\n  \n  .modal-header {\n    padding: 0.5rem;\n  }\n  \n  .modal-body {\n    padding: 0.5rem;\n    max-height: calc(85vh - 100px);\n  }\n  \n  .modal-footer {\n    padding: 0.5rem;\n  }\n  \n  /* Smaller text for very small screens */\n  .modal-title {\n    font-size: 1rem;\n  }\n  \n  .form-label {\n    font-size: 0.8rem;\n  }\n  \n  .btn {\n    font-size: 0.8rem;\n    padding: 0.5rem 0.75rem;\n  }\n  \n  /* Better spacing for form elements */\n  .row.g-3 > * {\n    margin-bottom: 0.75rem;\n  }\n  \n  /* Improve card spacing */\n  .card-body {\n    padding: 0.75rem;\n  }\n  \n  /* Better button sizing for small screens */\n  .btn-sm {\n    padding: 0.375rem 0.5rem;\n    font-size: 0.75rem;\n  }\n  \n  /* Reduce textarea height further */\n  textarea.form-control {\n    min-height: 60px;\n    max-height: 100px;\n  }\n  \n  /* Better modal positioning */\n  .modal.show {\n    padding: 0.25rem;\n  }\n}\n\n/* Critical fixes for modal overflow */\n@media (max-height: 600px) {\n  .modal-dialog {\n    max-height: 95vh;\n    margin: 0.25rem;\n  }\n  \n  .modal-content {\n    max-height: 95vh;\n  }\n  \n  .modal-body {\n    max-height: calc(95vh - 100px);\n    overflow-y: auto;\n  }\n  \n  /* Reduce textarea heights for short screens */\n  textarea.form-control {\n    min-height: 50px;\n    max-height: 80px;\n  }\n  \n  /* Stack form fields more aggressively */\n  .row .col-md-6,\n  .row .col-md-3 {\n    margin-bottom: 0.75rem;\n  }\n  \n  /* Reduce spacing */\n  .mb-3 {\n    margin-bottom: 0.75rem !important;\n  }\n  \n  .card-body {\n    padding: 0.5rem;\n  }\n}\n\n/* Additional fixes for very tall modals */\n@media (max-height: 800px) {\n  .modal-dialog {\n    max-height: 90vh;\n  }\n  \n  .modal-content {\n    max-height: 90vh;\n  }\n  \n  .modal-body {\n    max-height: calc(90vh - 120px);\n    overflow-y: auto;\n  }\n  \n  /* Reduce textarea heights */\n  textarea.form-control {\n    min-height: 60px;\n    max-height: 100px;\n  }\n  \n  /* Reduce form spacing */\n  .mb-3 {\n    margin-bottom: 0.75rem !important;\n  }\n  \n  .card-body {\n    padding: 0.75rem;\n  }\n  \n  /* Better button spacing */\n  .d-flex.justify-content-between {\n    margin-bottom: 0.75rem;\n  }\n}\n\n/* Fix for modal content overflow */\n.modal-dialog-scrollable .modal-content {\n  max-height: 100vh;\n  overflow: hidden;\n}\n\n.modal-dialog-scrollable .modal-body {\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n/* Better form field spacing */\n.form-group {\n  margin-bottom: 1rem;\n}\n\n.form-group:last-child {\n  margin-bottom: 0;\n}\n\n/* Improve textarea resizing */\ntextarea.form-control {\n  resize: vertical;\n  min-height: 60px;\n}\n\n/* Better modal backdrop */\n.modal-backdrop {\n  backdrop-filter: blur(4px);\n}\n\n/* Comprehensive modal fixes for fixed sidebar */\n.modal,\n.modal.show {\n  z-index: 1500 !important;\n}\n\n.modal-backdrop,\n.modal-backdrop.show {\n  z-index: 1400 !important;\n}\n\n/* Ensure all modals appear above sidebar */\n.modal-dialog {\n  z-index: 1500 !important;\n}\n\n.modal-content {\n  z-index: 1500 !important;\n}\n\n/* Ensure modals appear above sidebar */\n.modal.show {\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  z-index: 1500 !important;\n}\n\n/* Responsive modal positioning to account for fixed sidebar */\n@media (min-width: 992px) {\n  .modal.show {\n    padding-left: calc(280px + 1rem) !important; /* Account for sidebar width */\n  }\n  \n  .modal-dialog {\n    margin-left: auto !important;\n    margin-right: auto !important;\n  }\n}\n\n@media (max-width: 991px) {\n  .modal.show {\n    padding: 0.5rem !important;\n  }\n}\n\n@media (max-width: 768px) {\n  .modal.show {\n    padding: 0.5rem !important;\n  }\n}\n\n@media (max-width: 576px) {\n  .modal.show {\n    padding: 0.25rem !important;\n  }\n}\n\n/* --------------------------------------------------------------------------\n   Global modal responsiveness — applies to every Bootstrap modal in the app\n   (fixes inline maxWidth, overflow on small viewports, and notched devices)\n   -------------------------------------------------------------------------- */\n.modal {\n  overflow-x: hidden;\n  -webkit-overflow-scrolling: touch;\n}\n\n/* Never wider than the viewport; respect Bootstrap size modifiers via --bs-modal-width */\n.modal .modal-dialog {\n  width: 100%;\n  max-width: min(var(--bs-modal-width, 500px), calc(100vw - 1.5rem)) !important;\n  margin-left: auto !important;\n  margin-right: auto !important;\n}\n\n/* Cap modal height; keep header/footer visible, scroll the body */\n.modal .modal-content {\n  max-height: min(92vh, 92dvh);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.modal .modal-header,\n.modal .modal-footer {\n  flex-shrink: 0;\n}\n\n.modal .modal-body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n/* Users page (and similar): <form> wraps .modal-body + .modal-footer */\n.modal .modal-content > form {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.modal .modal-content > form .modal-body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.modal .modal-content > form .modal-footer {\n  flex-shrink: 0;\n}\n\n@media (max-width: 991px) {\n  .modal.show {\n    padding-left: max(0.5rem, env(safe-area-inset-left, 0px)) !important;\n    padding-right: max(0.5rem, env(safe-area-inset-right, 0px)) !important;\n    padding-bottom: max(0.5rem, env(safe-area-inset-bottom, 0px)) !important;\n  }\n}\n\n@media (max-height: 520px) {\n  .modal.show {\n    align-items: flex-start !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
